"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var propertyTypeBuilder = function propertyTypeBuilder(_a, context) {
  var _b = _a.categories,
      categories = _b === void 0 ? [] : _b;

  if (!categories.length || categories.length === Object.keys(_SearchFilters.TypeValue).length || (context === null || context === void 0 ? void 0 : context.withoutPropertyType)) {
    return '';
  }

  var propertyArray = categories.reduce(function (array, category) {
    switch (category) {
      case _SearchFilters.TypeValue.PRIVATE_ROOM:
        return __spreadArrays(array, ['propertyType:PRIVATE_ROOM']);

      case _SearchFilters.TypeValue.SHARED_ROOM:
        return __spreadArrays(array, ['propertyType:SHARED_ROOM']);

      case _SearchFilters.TypeValue.APARTMENT:
        return __spreadArrays(array, ['propertyType:APARTMENT', 'propertyType:HOUSE']);

      case _SearchFilters.TypeValue.STUDIO:
        return __spreadArrays(array, ['propertyType:STUDIO']);

      default:
        return array;
    }
  }, []);

  if (propertyArray.length === 1) {
    return propertyArray[0];
  }

  if (propertyArray.length > 1) {
    return "(" + propertyArray.join(' OR ') + ")";
  }

  return '';
};

var _default = propertyTypeBuilder;
exports["default"] = _default;